import React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";

import { useStyles } from "../styles/CodeJamOptionCard.styles";

const CodeJamOptionCard = ({ logo, logoAlt, onClick, className = "", children }) => {
  const classes = useStyles();

  return (
    <ButtonBase focusRipple className={`${classes.card} ${className}`} onClick={onClick}>
      <img alt={logoAlt} className={classes.logo} src={logo} />
      <Typography component="p" className={classes.description}>
        {children}
      </Typography>
    </ButtonBase>
  );
};

export default CodeJamOptionCard;
